const getPageReferrer = (location: { pathname: string, search: string }) => {
    const defaultUrl = location?.pathname + location?.search;
  
    const dataLayerTemp = window.dataLayer
        ? [...window.dataLayer].reverse()
        : [];

    const lastVirtualPageViewEvent =
        dataLayerTemp.find((element) => element.event === "virtualPageView") ||
        {};
    return lastVirtualPageViewEvent?.url || defaultUrl;
};

export default getPageReferrer;